import { render, staticRenderFns } from "./CsCompany.vue?vue&type=template&id=a68b5e5c&scoped=true&"
import script from "./CsCompany.vue?vue&type=script&lang=js&"
export * from "./CsCompany.vue?vue&type=script&lang=js&"
import style0 from "./CsCompany.vue?vue&type=style&index=0&id=a68b5e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68b5e5c",
  null
  
)

export default component.exports